// extracted by mini-css-extract-plugin
export default {"table":"Schedule_table__+6ORF"};